import React from "react";
import Popup from "src/components/popup/Popup";
import CopyClipboard from "src/pages/AccessControl/pages/Re_fresh/CopyClipboard";

const ReFreshGenerateKeyPopup = ({
  openPopup,
  setOpenPopup,
  dataGenerateKey,
}) => {
  return (
    <Popup
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "1200px", // Set your width here
          },
        },
      }}
      title="Detail Key Generate"
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
    >
      <table className="tableFixed">
        <thead>
          <tr>
            <td>Type</td>
            <td>Key</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr key="publicKey">
            <td>Public Key</td>
            <td className="tdFixed">{dataGenerateKey.publicKey}</td>
            <td>
              <CopyClipboard dataCopy={dataGenerateKey.publicKey} />
            </td>
          </tr>
          <tr key="privateKey">
            <td>Private Key</td>
            <td className="tdFixed">{dataGenerateKey.privateKey}</td>
            <td>
              <CopyClipboard dataCopy={dataGenerateKey.privateKey} />
            </td>
          </tr>
        </tbody>
      </table>
    </Popup>
  );
};

export default ReFreshGenerateKeyPopup;
